import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useMemo } from 'react';

import { SmsOptedOutWarningPopupController } from './sms-opted-out-warning-popup.controller';

const SmsOptedOutWarningPopupModal = NiceModal.create(SmsOptedOutWarningPopupController);

export const useSmsOptedOutWarningPopup = () => {
  const { show } = useModal(SmsOptedOutWarningPopupModal);
  return useMemo(() => ({ open: show }), [show]);
};
